import Trending from "./trending.component";

export default Trending;
